var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareTabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_black_24dp 1",
    clipPath: "url(#clip0_1279_14128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8008 13.264C14.1928 13.264 13.6488 13.504 13.2328 13.88L7.52878 10.56C7.56878 10.376 7.60078 10.192 7.60078 10C7.60078 9.808 7.56878 9.624 7.52878 9.44L13.1688 6.152C13.6008 6.552 14.1688 6.8 14.8008 6.8C16.1288 6.8 17.2008 5.728 17.2008 4.4C17.2008 3.072 16.1288 2 14.8008 2C13.4728 2 12.4008 3.072 12.4008 4.4C12.4008 4.592 12.4328 4.776 12.4728 4.96L6.83278 8.248C6.40078 7.848 5.83278 7.6 5.20078 7.6C3.87278 7.6 2.80078 8.672 2.80078 10C2.80078 11.328 3.87278 12.4 5.20078 12.4C5.83278 12.4 6.40078 12.152 6.83278 11.752L12.5288 15.08C12.4888 15.248 12.4648 15.424 12.4648 15.6C12.4648 16.888 13.5128 17.936 14.8008 17.936C16.0888 17.936 17.1368 16.888 17.1368 15.6C17.1368 14.312 16.0888 13.264 14.8008 13.264Z",
    fill: "#CB804B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_14128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.400391 0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTabs);
export default __webpack_public_path__ + "static/media/share_Tabs.3123e961ef065ff38aabb63624d52fbb.svg";
export { ForwardRef as ReactComponent };